import { set } from 'lodash';
import { LC_PLAYLIST, PROGRESS_START } from '../common/components/demoVideos/demoVideoConstants';

const { LC_PRACTICE } = LC_PLAYLIST;

export const getDemoVideoProgress = state => {
    const demoVideosProgress = { ...state.demoVideosProgress };
    set(demoVideosProgress, `${LC_PRACTICE.ID}.progress`, PROGRESS_START);
    set(demoVideosProgress, `${LC_PRACTICE.ID}.currentTime`, PROGRESS_START);
    return demoVideosProgress;
};
